import { Col, Row, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { openNotificationWithIcon } from "../../../../../utils/helper";
import { getClasses, getStudents } from "../../../../../api/class/class";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import Learningchart from "../../../student/studentprofile/studentprofilemain/charts/earningchart";
import Studentcard from "../../teacherstudents/studentcard/studentcard";
import Friendsmodal from "../../../student/studentprofile/studentfriends/friendsmodal/friendsmodal";

const Teacherstatistics = () => {
  const [currentStudent, setCurrentStudent] = useState(null);
  const [showStudent, setShowStudent] = useState(false);
  //@ts-ignore
  const [classes, setClasses] = useState([]);
  const [studentsDuration, setStudentsDuration] = useState(0);
  const [numberOfStudents, setNumberOfStudents] = useState(0);
  //@ts-ignore
  // eslint-disable-next-line
  const [numberOfTeachers, setNumberOfTeachers] = useState(0);
  //@ts-ignore
  // eslint-disable-next-line
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentList] = useState([]);

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

  const closeStudentModal = () => {
    setShowStudent(false);
  };

  const viewStudent = (studentDetails: any) => {
    setShowStudent(true);
    setCurrentStudent(studentDetails);
  };

  const fetchClasses = async () => {
    try {
      setLoadingClasses(true);
      const res = await getClasses({}, user?._id);
      const { data } = res?.data;
      setClasses(data);
      let newStudentCount = 0;
      let newStudentsDuration = 0;
      data.forEach((item: any) => {
        newStudentCount += item.students.length;
        item.students.forEach((itemInside: any) => {
          newStudentsDuration += itemInside?.duration;
        });
      });
      setNumberOfStudents(newStudentCount);
      setStudentsDuration(isNaN(newStudentsDuration) ? 0 : newStudentsDuration);
      setLoadingClasses(false);
    } catch (error: any) {
      setLoadingClasses(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Classes",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Classes",
          "Something went wrong"
        );
      }
    }
  };

  useEffect(() => {
    fetchClasses();

    // eslint-disable-next-line
  }, []);

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const res = await getStudents(user?._id);
      const { data } = res?.data;
      console.log(data);
      setStudentList(data);
      setLoading(false);
      setNumberOfStudents(data.length);
      // let newTotalFunPoints = 0
      // let newTotalFunKeys = 0
      // data.forEach((item: any) => {
      // 	newTotalFunPoints += item.wallet.funPoints
      // 	newTotalFunKeys += item.wallet.funKeys
      // });
      // setTotalFunPoints(newTotalFunPoints)
      // setTotalFunKeys(newTotalFunKeys)
    } catch (error: any) {
      setLoading(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Curriculums",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Curriculums",
          "Something went wrong"
        );
      }
    }
  };

  useEffect(() => {
    fetchStudents();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <p className="mb-4 text-xl font-semibold text-appcolorpurplefaintone">
            Statistics
          </p>

          <div>
            <Row gutter={16}>
              <Col xs={24} md={24} lg={12}>
                <div className="custom-tan-bg-linear mb-4 rounded-[1.5rem] p-4">
                  <div>
                    <div className="custom-deep-tan-bg-linear w-fit rounded-xl p-[0.3rem]">
                      <img
                        src="/img/vectors/students.svg"
                        alt="students"
                        className="w-8 h-8"
                      />
                    </div>

                    <p className="mt-4 text-xl text-appcolorpurplefaintone">
                      Students
                    </p>
                  </div>

                  <div className="mt-4">
                    <p className="text-2xl font-[900] text-appcolordeeptan">
                      {numberOfStudents}
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={24} md={24} lg={12}>
                <div className="custom-tan-bg-linear mb-4 rounded-[1.5rem] p-4">
                  <div>
                    <div className="custom-deep-tan-bg-linear w-fit rounded-xl p-[0.3rem]">
                      <img
                        src="/img/vectors/students.svg"
                        alt="students"
                        className="w-8 h-8"
                      />
                    </div>

                    <p className="mt-4 text-xl text-appcolorpurplefaintone">
                      Teachers
                    </p>
                  </div>

                  <div className="mt-4">
                    <p className="text-2xl font-[900] text-appcolordeeptan">
                      {numberOfTeachers}
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={24} md={24} lg={12}>
                <div className="custom-tan-bg-linear mb-4 rounded-[1.5rem] p-4">
                  <div>
                    <div className="custom-deep-tan-bg-linear w-fit rounded-xl p-[0.3rem]">
                      <img
                        src="/img/vectors/timespent.svg"
                        alt="students"
                        className="w-8 h-8"
                      />
                    </div>

                    <p className="mt-4 text-xl text-appcolorpurplefaintone">
                      Time Spent
                    </p>
                  </div>

                  <div className="mt-4">
                    <p className="text-2xl font-[900] text-appcolordeeptan">
                      {/* 3hr 3min */}
                      {studentsDuration}
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={24} md={24} lg={12}>
                <div className="custom-tan-bg-linear mb-4 rounded-[1.5rem] p-4">
                  <div>
                    <div className="custom-deep-tan-bg-linear w-fit rounded-xl p-[0.3rem]">
                      <img
                        src="/img/vectors/classes.svg"
                        alt="students"
                        className="w-8 h-8"
                      />
                    </div>

                    <p className="mt-4 text-xl text-appcolorpurplefaintone">
                      Classes
                    </p>
                  </div>

                  <div className="mt-4">
                    <p className="text-2xl font-[900] text-appcolordeeptan">
                      {classes.length}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="mt-5">
              <p className="mb-4 text-xl font-semibold text-appcolorpurplefaintone">
                Funpoints
              </p>
              <Learningchart />
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <p className="mb-4 text-xl font-semibold text-appcolorpurplefaintone">
            Leaderboard
          </p>

          <div className="mt-4">
            {loading ? (
              <>
                {[3, 4, 5].map((item) => (
                  <Skeleton.Button
                    key={`loading-students-${item}`}
                    active={true}
                    size={"large"}
                    shape={"square"}
                    block={true}
                    style={{
                      height: "4rem",
                      width: "100%",
                      marginBottom: "1rem",
                    }}
                  />
                ))}
              </>
            ) : (
              <>
                {studentList?.length === 0 ? (
                  <>
                    <p className="tex-base text-appcolorblackfainteleven">
                      {" "}
                      Data currently unavailable
                    </p>
                  </>
                ) : (
                  studentList.map((item: any, index: number) => (
                    <Studentcard
                      key={`your-students-${item?._id}`}
                      item={item}
                      index={index}
                      showOptions
                      viewStudent={viewStudent}
                      offRankingNumber={true}
                      optionsWithoutAssign={true}
                      showTotalFP={true}
                    />
                  ))
                )}
              </>
            )}
          </div>
        </Col>
      </Row>

      {showStudent ? (
        <Friendsmodal
          open={showStudent}
          closeModal={closeStudentModal}
          studentDetails={currentStudent}
          viewing="teacher"
        />
      ) : null}
    </div>
  );
};

export default Teacherstatistics;
